<template>
  <div id="app" :class="{ 'pinkki-ui': usePinkkiTheme }">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  computed: {
    usePinkkiTheme() {
      const path = this.$route.path
      return path !== '/' && path !== '/stock' && path !== '/chain' && path !== '/test'
        && !path.split('/').includes('admin') && !this.$route.meta.darkMode
    }
  }
}
</script>

<style lang="less" src="./styles/pinkki.less"></style>
<style>
:root {
  --v-main-pink:rgb(255, 237, 251);
  --v-dark-color:#160221;
}

body, html, #app {
  padding: 0;
  margin: 0;
  font-family: Avenir, Helvetica, PingFangSC-Regular, "Microsoft Yahei", "Microsoft YaHei", "微软雅黑", 微软雅黑, Arial, sans-serif;
}
body {
  background-color: var(--v-main-pink);
  transition: background-color .5s;
}
body.dark-mode {
  background-color: var(--v-dark-color);
}

h1, h2, h3, h4, h5, p {
  margin: 0;
}


.van-button--info {
  background-color: rgb(235, 94, 165)!important;
  border-color: rgb(235, 94, 165)!important;
}
.van-button--info.van-button--plain {
  background-color: #fff!important;
  color: rgb(235, 94, 165)!important;
}
.main-wrapper {
  max-width: 800px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, .9);
  padding-bottom: 20px;
}
.basic-header {
  text-indent: 12px;
  padding: 8px 0;
}
</style>
